import * as server from '../entries/pages/(admin)/admin/_layout.server.ts.js';

export const index = 2;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/(admin)/admin/_layout.svelte.js')).default;
export { server };
export const server_id = "src/routes/(admin)/admin/+layout.server.ts";
export const imports = ["_app/immutable/nodes/2.BBwUq5U0.js","_app/immutable/chunks/Cew_q46a.js","_app/immutable/chunks/DiR_Syld.js","_app/immutable/chunks/zAv0u1wk.js","_app/immutable/chunks/B6Ikv-5C.js","_app/immutable/chunks/58wTqVZX.js","_app/immutable/chunks/BkRTvK_t.js","_app/immutable/chunks/C-ONJZal.js","_app/immutable/chunks/BCt2Yrch.js","_app/immutable/chunks/B_dIkPng.js","_app/immutable/chunks/DycBIGr7.js","_app/immutable/chunks/DcKRL2at.js"];
export const stylesheets = ["_app/immutable/assets/2.jJCZVnCa.css"];
export const fonts = [];
